import * as tslib_1 from "tslib";
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore as reduxCreateStore } from 'redux';
var DEFAULT_MIDDLEWARES = [thunk, promiseMiddleware()];
export var createAppStore = function createAppStore(reducer, origEnhancer) {
  var enhancer = applyMiddleware.apply(void 0, tslib_1.__spread(DEFAULT_MIDDLEWARES));

  if (origEnhancer) {
    enhancer = compose(enhancer, origEnhancer);
  }

  return reduxCreateStore(reducer, enhancer);
};